import { delay, call, takeLatest, select } from "redux-saga/effects";
import { browserHistory } from "react-router";
import {
  FETCH_LIST_CREDIT_CERTIFICATE,
  FETCH_CREDIT_CERTIFICATE_BY_ID,
  SAVE_CREDIT_CERTIFICATE,
  DELETE_CREDIT_CERTIFICATE,
} from "../../constants/constant_saga_types";
import * as sagaCommon from "../sagasCommon";
import * as apiCommon from "../../services/apiCommon";
import * as apiCreditCertificate from "../../services/credit_certificate/api_credit_certificate";
import messages from "../../components/admin/certificates/translation_credit_certificate";
import { CREDIT_CERTIFICATE } from "../../constants/constant_doc_types";

export function* fetchListCreditCertificateSaga(feathersApp) {
  yield takeLatest(
    FETCH_LIST_CREDIT_CERTIFICATE,
    callFetchListCreditCertificate,
    feathersApp
  );
}

function* callFetchListCreditCertificate(feathersApp, action) {
  try {
    const { silent, filters } = action;
    yield sagaCommon.showProgressListTable(silent);
    const dataParams = {
      filters,
      list_type: "credit_certificate"
    };
    const tableData = yield call(
      apiCommon.getDocs,
      feathersApp,
      dataParams
    );
    yield sagaCommon.doneListTable({
      rows: tableData.data,
      total_rows: tableData.total
    });
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorListTable(e);
  }
}

export function* fetchCreditCertificateByIdSaga(feathersApp) {
  yield takeLatest(
    FETCH_CREDIT_CERTIFICATE_BY_ID,
    callFetchCreditCertificateById,
    feathersApp
  );
}

function* callFetchCreditCertificateById(feathersApp, action) {
  try {
    yield sagaCommon.showProgressDataById();
    const { id } = action;
    if (id) {
      const creditCertificate = yield call(
        apiCreditCertificate.fetchCreditCertificateById,
        feathersApp,
        id
      );
      yield sagaCommon.doneDataById(creditCertificate);
    } else {
      const initialValues = {
        active: true,
        is_allocated: false
      };
      yield sagaCommon.doneDataById(initialValues);
    }
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorDataById(e);
  }
}

export function* saveCreditCertificateSaga(feathersApp) {
  yield takeLatest(
    SAVE_CREDIT_CERTIFICATE,
    callSaveCreditCertificate,
    feathersApp
  );
}

function* callSaveCreditCertificate(feathersApp, action) {
  try {
    const { intl } = yield select();
    const { data } = action;
    yield sagaCommon.showProgressSaveRecord();
    const result = yield call(
      apiCreditCertificate.saveCreditCertificate,
      feathersApp,
      data
    );
    const id = result.id || result[0].id;
    browserHistory.push(`/admin/certificate/edit/${id}`);
    yield sagaCommon.doneSaveRecord(
      result,
      intl.formatMessage(messages.saved_certificate)
    );
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorDataById(e);
  }
}

export function* deleteCreditCertificateSaga(feathersApp) {
  yield takeLatest(
    DELETE_CREDIT_CERTIFICATE,
    callDeleteCreditCertificate,
    feathersApp
  );
}

function* callDeleteCreditCertificate(feathersApp, action) {
  try {
    const { id } = action;
    if (id) {
      yield sagaCommon.showProgressDeleteRecord();
      yield call(
        apiCreditCertificate.deleteCreditCertificate,
        feathersApp,
        id
      );
      yield delay(2000); 
      yield sagaCommon.doneDeleteRecord(id, CREDIT_CERTIFICATE);
      browserHistory.push('/admin/certificate');
    }
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorDeleteRecord(e);
  }
}
